import { render, staticRenderFns } from "./secondary.vue?vue&type=template&id=3136a74b&scoped=true&"
import script from "./secondary.vue?vue&type=script&lang=js&"
export * from "./secondary.vue?vue&type=script&lang=js&"
import style0 from "./secondary.vue?vue&type=style&index=0&id=3136a74b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136a74b",
  null
  
)

export default component.exports